import '@/common/error_page.less'

// 404.js
document.addEventListener('DOMContentLoaded', function() {
    // 获取DOM元素
    const errorTitleElement = document.querySelector('.error-title')
    const errorMessageElement = document.querySelector('.error-message')

    // 根据用户语言显示错误消息
    const language = navigator.language || navigator.userLanguage
    const isChinese = language.startsWith('zh')

    if (isChinese) {
        errorTitleElement.textContent = '404 找不到页面'
        errorMessageElement.textContent = '请求的页面不存在。'
    } else {
        errorTitleElement.textContent = '404 Page Not Found'
        errorMessageElement.textContent = 'The requested page does not exist.'
    }
})